import api from "@/utils/http";

export * from './type'
export * from './business'

/**
 功能：
 time: 2025-51-03 14:51:23
 **/
export function getCompanyConfig() {
    return api.get('/admin/company/getSetConfig')
}
/**
 功能：
 time: 2025-51-03 13:51:33
 **/
export function getCompanyList(data) {
    return api.post('/admin/company/getList', data)
}
/**
 功能：
 time: 2025/12/16 11:02
 **/
export function getCompanySelectList() {
    return api.get('/admin/company/getSearchList')
}
/**
 功能：保存
 time: 2025-38-02 16:38:38
 **/
export function saveCompany(data) {
    return api.post('/admin/company/eSave', data)
}

/**
 功能：
 time: 2026/1/5 15:13
 **/
export function getCompanyAccount(company_id) {
    return api.post('/admin/company/getAccount', {company_id})
}


/**
 功能：
 time: 2025-42-02 16:42:10
 **/
export function getCompanyDetail(company_id) {
    return api.post('/admin/company/getDetail', {company_id })
}
/**
 功能：
 time: 2025-48-03 17:48:41
 **/
export function deleteCompany(company_id) {
    return api.post('/admin/company/del', {company_id})
}

/**
 功能：
 time: 2025-48-03 17:48:43
 **/
export function deleteAllCompany(companyIds) {
    return api.post('/admin/company/delAll', {companyIds})
}